var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("div", { staticClass: "header col-md-12" }, [
      _c("div", { staticClass: "header-inner row align-items-center" }, [
        _c("div", { staticClass: "col left" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("sidebar.overviews")) +
                "\n        "
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content col-md-12" }, [
      !_vm.ready
        ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
        : _vm._e(),
      _vm._v(" "),
      _vm.ready
        ? _c("div", { staticClass: "col-md-12 p-0 m-0 row" }, [
            _c("div", { staticClass: "col-md-12 col-lg-6" }, [
              _c("div", { staticClass: "col-md-12 card" }, [
                _c("div", { staticClass: "form-row mt-2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-9",
                      staticStyle: { position: "relative" }
                    },
                    [
                      _c("div", {
                        staticStyle: {
                          width: "1px",
                          height: "50%",
                          background: "rgba(0,0,0,.1)",
                          position: "absolute",
                          top: "18px",
                          right: "0"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-1 mb-1" }, [
                        _c("strong", { staticStyle: { "font-size": "16px" } }, [
                          _vm._v(_vm._s(_vm.$t("message.outstandinginvoice")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "span",
                          {
                            staticClass: "text-info",
                            staticStyle: { "font-size": "28px" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.currencyFormatter(
                                  _vm.outstanding_invoice_total,
                                  { code: this.currency }
                                )
                              )
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-3 text-center" }, [
                    _c(
                      "div",
                      {
                        staticClass: "row align-items-center",
                        staticStyle: { height: "100%" }
                      },
                      [
                        _c("div", { staticClass: "col" }, [
                          _c("div", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.debits.outstanding_invoice.length) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t("apps.accounts.message.totalinvoices")
                                ) +
                                "\n                  "
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "8px 0 0 0" } }),
                _vm._v(" "),
                _c("div", { staticClass: "form-row mt-1" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-12",
                      staticStyle: { "min-height": "250px" }
                    },
                    [
                      _vm.debits.outstanding_invoice.length == 0
                        ? _c(
                            "div",
                            {
                              staticClass: "text-center mb-0",
                              staticStyle: { height: "100%" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "row align-items-center",
                                  staticStyle: { height: "100%" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col text-center",
                                      staticStyle: {
                                        position: "relative",
                                        top: "-16px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t("message.notfounddata")
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.debits.outstanding_invoice.length > 0
                        ? _c(
                            "table",
                            {
                              staticClass: "table mb-2",
                              staticStyle: { border: "none" }
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        "border-top":
                                          "1px solid rgba(0,0,0,.1)",
                                        border: "none",
                                        padding: "5px 0 5px 0"
                                      }
                                    },
                                    [
                                      _c(
                                        "strong",
                                        { staticStyle: { color: "#999" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.series"))
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        "border-top":
                                          "1px solid rgba(0,0,0,.1)",
                                        border: "none",
                                        padding: "5px 0 5px 0"
                                      }
                                    },
                                    [
                                      _c(
                                        "strong",
                                        { staticStyle: { color: "#999" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.customer"))
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        "border-top":
                                          "1px solid rgba(0,0,0,.1)",
                                        border: "none",
                                        padding: "5px 0 5px 0"
                                      }
                                    },
                                    [
                                      _c(
                                        "strong",
                                        { staticStyle: { color: "#999" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.debttotal"))
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    {
                                      staticClass: "text-center",
                                      staticStyle: {
                                        "border-top":
                                          "1px solid rgba(0,0,0,.1)",
                                        border: "none",
                                        padding: "5px 0 5px 0"
                                      }
                                    },
                                    [
                                      _c(
                                        "strong",
                                        { staticStyle: { color: "#999" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.scheduled_at")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.debits.outstanding_invoice, function(
                                  item,
                                  index
                                ) {
                                  return _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          border: "none",
                                          padding: "5px 0 5px 0"
                                        }
                                      },
                                      [
                                        _c("router-link-custom", {
                                          attrs: {
                                            to: {
                                              name: "AccountsInvoiceEdit",
                                              query: {
                                                in_id: item.in_id,
                                                in_code: item.in_code
                                              }
                                            },
                                            text: item.in_code,
                                            status: {
                                              text: _vm.getInvoiceStatus(
                                                item,
                                                _vm.$t,
                                                _vm.mixin
                                              ).message,
                                              color: _vm.getColorFormStatus(
                                                _vm.getInvoiceStatus(
                                                  item,
                                                  _vm.$t,
                                                  _vm.mixin
                                                ).status
                                              ),
                                              type: "icon"
                                            },
                                            to_appid: 12,
                                            current_appid: 12
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          border: "none",
                                          padding: "5px 0 5px 0"
                                        }
                                      },
                                      [
                                        item.customer
                                          ? _c("router-link-custom", {
                                              attrs: {
                                                to: {
                                                  name: "ContactCustomerEdit",
                                                  query: {
                                                    cus_id:
                                                      item.customer.customer_id,
                                                    cus_name:
                                                      item.customer
                                                        .customer_name
                                                  }
                                                },
                                                text:
                                                  item.customer.customer_name,
                                                to_appid: 11,
                                                current_appid: 12,
                                                disabled:
                                                  item.customer.is_deleted ==
                                                  true
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          border: "none",
                                          padding: "5px 0 5px 0"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.getNumber(
                                                _vm.getDebtInvoiceAmount(item)
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: {
                                          border: "none",
                                          padding: "5px 0 5px 0"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.getDate(item.scheduled_at)
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ])
                                }),
                                0
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-12 col-lg-6" }, [
              _c("div", { staticClass: "col-md-12 card" }, [
                _c("div", { staticClass: "form-row mt-2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-9",
                      staticStyle: { position: "relative" }
                    },
                    [
                      _c("div", {
                        staticStyle: {
                          width: "1px",
                          height: "50%",
                          background: "rgba(0,0,0,.1)",
                          position: "absolute",
                          top: "18px",
                          right: "0"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-1 mb-1" }, [
                        _c("strong", { staticStyle: { "font-size": "16px" } }, [
                          _vm._v(_vm._s(_vm.$t("message.outstandingpayment")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "span",
                          {
                            staticClass: "text-info",
                            staticStyle: { "font-size": "28px" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.currencyFormatter(
                                  _vm.outstanding_payment_total,
                                  { code: this.currency }
                                )
                              )
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-3 text-center" }, [
                    _c(
                      "div",
                      {
                        staticClass: "row align-items-center",
                        staticStyle: { height: "100%" }
                      },
                      [
                        _c("div", { staticClass: "col" }, [
                          _c("div", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.debits.outstanding_payment.length) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t("apps.accounts.message.totalpayments")
                                ) +
                                "\n                  "
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "8px 0 0 0" } }),
                _vm._v(" "),
                _c("div", { staticClass: "form-row mt-1" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-12",
                      staticStyle: { "min-height": "250px" }
                    },
                    [
                      _vm.debits.outstanding_payment.length == 0
                        ? _c(
                            "div",
                            {
                              staticClass: "text-center mb-0",
                              staticStyle: { height: "100%" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "row align-items-center",
                                  staticStyle: { height: "100%" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col text-center",
                                      staticStyle: {
                                        position: "relative",
                                        top: "-16px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t("message.notfounddata")
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.debits.outstanding_payment.length > 0
                        ? _c(
                            "table",
                            {
                              staticClass: "table mb-2",
                              staticStyle: { border: "none" }
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        "border-top":
                                          "1px solid rgba(0,0,0,.1)",
                                        border: "none",
                                        padding: "5px 0 5px 0"
                                      }
                                    },
                                    [
                                      _c(
                                        "strong",
                                        { staticStyle: { color: "#999" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.series"))
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        "border-top":
                                          "1px solid rgba(0,0,0,.1)",
                                        border: "none",
                                        padding: "5px 0 5px 0"
                                      }
                                    },
                                    [
                                      _c(
                                        "strong",
                                        { staticStyle: { color: "#999" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.vendor"))
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        "border-top":
                                          "1px solid rgba(0,0,0,.1)",
                                        border: "none",
                                        padding: "5px 0 5px 0"
                                      }
                                    },
                                    [
                                      _c(
                                        "strong",
                                        { staticStyle: { color: "#999" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.debttotal"))
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    {
                                      staticClass: "text-center",
                                      staticStyle: {
                                        "border-top":
                                          "1px solid rgba(0,0,0,.1)",
                                        border: "none",
                                        padding: "5px 0 5px 0"
                                      }
                                    },
                                    [
                                      _c(
                                        "strong",
                                        { staticStyle: { color: "#999" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.scheduled_at")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.debits.outstanding_payment, function(
                                  item,
                                  index
                                ) {
                                  return _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          border: "none",
                                          padding: "5px 0 5px 0"
                                        }
                                      },
                                      [
                                        [
                                          item.po_id
                                            ? _c("router-link-custom", {
                                                attrs: {
                                                  to: {
                                                    name: "PurchaseOrderEdit",
                                                    query: {
                                                      id: item.po_id,
                                                      code: item.po_code
                                                    }
                                                  },
                                                  text: item.po_code,
                                                  status: {
                                                    text: _vm.getPurchaseStatus(
                                                      item,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).message,
                                                    color: _vm.getColorFormStatus(
                                                      _vm.getPurchaseStatus(
                                                        item,
                                                        _vm.$t,
                                                        _vm.mixin
                                                      ).status
                                                    ),
                                                    type: "icon"
                                                  },
                                                  to_appid: 4,
                                                  current_appid: 4
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.ex_id
                                            ? _c("router-link-custom", {
                                                attrs: {
                                                  to: {
                                                    name: "ExpensesClaimEdit",
                                                    query: {
                                                      ex_id: item.ex_id,
                                                      ex_code: item.ex_code
                                                    }
                                                  },
                                                  text: item.ex_code,
                                                  status: {
                                                    text: _vm.getExpenseStatus(
                                                      item,
                                                      _vm.$t,
                                                      _vm.mixin
                                                    ).message,
                                                    color: _vm.getColorFormStatus(
                                                      _vm.getExpenseStatus(
                                                        item,
                                                        _vm.$t,
                                                        _vm.mixin
                                                      ).status
                                                    ),
                                                    type: "icon"
                                                  },
                                                  to_appid: 6,
                                                  current_appid: 6
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.prl_id
                                            ? _c("router-link-custom", {
                                                attrs: {
                                                  to: {
                                                    name: "PaySlipEdit",
                                                    query: {
                                                      id: item.prl_id,
                                                      code: item.prl_code
                                                    }
                                                  },
                                                  text: item.prl_code,
                                                  status: {
                                                    text: _vm.$t(
                                                      "process.prl." +
                                                        item.process.status
                                                    ),
                                                    color: _vm.getColorFormStatus(
                                                      "uncompleted"
                                                    ),
                                                    type: "icon"
                                                  },
                                                  to_appid: 14,
                                                  current_appid: 6
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          border: "none",
                                          padding: "5px 0 5px 0"
                                        }
                                      },
                                      [
                                        [
                                          item.vendor && item.po_id
                                            ? _c("router-link-custom", {
                                                attrs: {
                                                  to: {
                                                    name: "ContactVendorEdit",
                                                    query: {
                                                      ven_id:
                                                        item.vendor.vendor_id,
                                                      ven_name:
                                                        item.vendor.vendor_name
                                                    }
                                                  },
                                                  text: item.vendor.vendor_name,
                                                  to_appid: 11,
                                                  current_appid: 4,
                                                  disabled:
                                                    item.vendor.is_deleted ==
                                                    true
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.ex_id
                                            ? _c("span", [_vm._v("-")])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.prl_id
                                            ? _c("span", [_vm._v("-")])
                                            : _vm._e()
                                        ]
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          border: "none",
                                          padding: "5px 0 5px 0"
                                        }
                                      },
                                      [
                                        [
                                          item.po_id
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getNumber(
                                                      _vm.getDebtPurchaseAmount(
                                                        item
                                                      )
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.ex_id
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getNumber(
                                                      _vm.getDebtExpenseAmount(
                                                        item
                                                      )
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.prl_id
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getNumber(
                                                      _vm.getDebtPayslipAmount(
                                                        item
                                                      )
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: {
                                          border: "none",
                                          padding: "5px 0 5px 0"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              item.prl_id
                                                ? "-"
                                                : _vm.getDate(item.scheduled_at)
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ])
                                }),
                                0
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-992c2bb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-992c2bb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/accounts/overview/All.vue
// module id = null
// module chunks = 